// Test URLs configuration
// Add, remove, or modify URLs here for easy maintenance

export const testUrls = [
    '',
    '/angebote',
    '/myproducts',
    '/productList?search=nesquik',
    '/c/vegane-vielfalt',
    '/c/milch',
    '/p/chiquita-banane-ca-200g/7230923',
    '/mydata/orderhistory',
    '/mydata/orderdetail/B-9VQ-GFB-9L2?constraint=rewe',
    '/checkout/basket',
    '/mydata/meine-einkaeufe',
    '/mydata/privacy'
];
